export interface MarketplaceLocation {
  placeId: string
  description: string
}

export function prepareLocationData(
  placeId: string,
  description: string
): MarketplaceLocation | null {
  if (placeId) {
    return {
      placeId,
      description
    }
  } else {
    return null
  }
}
export function prepareSelectedLocation(
  location: MarketplaceLocation
): Array<MarketplaceLocation> {
  return location ? Array(location) : []
}
